"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _cmsDesignComponent = require("@tencent/cms-design-component");
require("../../common/style.scss");
var _formatVodData = require("../../utils/formatVodData");
var _urlUtils = require("../../common/utils/domain/urlUtils");
var _reportUtil = require("../../utils/reportUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const formatProductIntroduction = (properties, {
  domains
} = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? [] : _properties$configura; // 第一条数据是模块名称
  const list = configuration.map((item, index) => {
    const value = item;
    const formattedHref = formatUrlString(value.imageBgTextHref || '');
    const extendProps = {
      'report-event': 'click_productIntroduction_video',
      'report-ext1': index,
      'report-ext2': value.filedVideoList || ''
    };
    if (value.filedVideoBg) {
      value.imageUrl = (0, _formatVodData.formatVodData)(value.filedVideoBg).url;
    }
    value.imageBgTextHref = formattedHref;
    value.extendProps = extendProps;
    value.extendProps1 = {
      'report-event': 'click_productIntroduction_href',
      'report-ext1': index,
      'report-ext2': value.imageBgText || '',
      'report-ext3': formattedHref
    };
    value.article = formatUrlInText(value.article || '', {
      reportEvent: 'click_productIntroduction_detail_richtext_href'
    });
    value.postMessageUrl = (0, _urlUtils.getVideoIframeUrl)();
    return value;
  });
  return {
    modTitle,
    configuration: list,
    bgColor: color
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  const componentData = data;
  if (componentData) {
    const _formatProductIntrodu = formatProductIntroduction(componentData, {
        domains
      }),
      _formatProductIntrodu2 = _formatProductIntrodu.configuration,
      configuration = _formatProductIntrodu2 === void 0 ? [] : _formatProductIntrodu2,
      _formatProductIntrodu3 = _formatProductIntrodu.modTitle,
      modTitle = _formatProductIntrodu3 === void 0 ? '' : _formatProductIntrodu3,
      bgColor = _formatProductIntrodu.bgColor;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色

    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_productIntroduction', componentKey, modTitle])), /*#__PURE__*/React.createElement(_cmsDesignComponent.ProductIntroduction, {
      configuration: configuration,
      flexTitle: modTitle,
      style: bgStyle
    }));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
}